export default {
	login: 'Log in',
	unexpectedError: 'An unexpected error occurred. Please try again.',
	requireField: 'Required field',
	invalidFormat: 'Invalide format',
	invalidMinValue: 'Invalid min value: {minValue}',
	userNameOrPassWordIsInCorrect: 'Username or password is incorrect.',
	tooManyAttempts: 'Temporary disable, please try again later',
	accountInactive: 'This account is inactive. Please contact the admin.',
	requireChecked: 'Required checked',
	invalidNumber: 'Please enter numbers only',
	invalidLength: 'Please enter the code with the correct number of digits',
	form: {
		title: 'Log in to Your Account',
		description: 'กรุณากรอกข้อมูลเพื่อเข้าสู่ระบบ <a href="#" target="_blank" rel="noopener noreferrer">STU</a>',
		button: {
			submit: 'เข้าสู่ระบบ',
			submitCoutdown: 'เข้าสู่ระบบได้อีกครั้งใน {seconds} วินาที',
		},
	},
};
